import { render, staticRenderFns } from "./seach.vue?vue&type=template&id=0a725004&scoped=true"
import script from "./seach.vue?vue&type=script&lang=js"
export * from "./seach.vue?vue&type=script&lang=js"
import style0 from "./seach.vue?vue&type=style&index=0&id=0a725004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a725004",
  null
  
)

export default component.exports